import React, { useCallback } from 'react'
import { connect } from 'dva'
import { Modal, message } from 'antd'
import IconFont from '@/components/Icon'
import PageWrapper from '@/components/PageWrapper'
import AddIdCard from './AddIdCard'
import { deleteIdCard } from '../../../api/idCard'
import './Info.module.less'

const IdCard = ({ dispatch, idCardCheck }) => {
  const handleDelete = useCallback(() => {
    Modal.confirm({
      centered: true,
      content: '确认删除该身份证吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        deleteIdCard().then((res) => {
          if (res.code === 0) {
            dispatch({
              type: 'global/getIdCardCheck',
            })
          } else {
            message.error(res.message)
          }
        })
        // dispatch({
        //   type: 'center/deletePersonalIdCard',
        //   payload: {
        //     params: {
        //       user: 'test',
        //     },
        //   },
        // }).then(() => {
        //   dispatch({
        //     type: 'global/getPersonalIdCard',
        //   })
        // })
      },
    })
  }, [dispatch])
  const handleAddIdCard = useCallback(() => {
    dispatch({
      type: 'center/save',
      payload: {
        addIdCardVisible: true,
      },
    })
  }, [dispatch])
  return (
    <div style={{ marginTop: '-40px' }}>
      <PageWrapper
        subTitle={
          <div styleName="query-box">
            <span styleName="title">身份证管理</span>
          </div>
        }
      >
        <div style={{ overflow: 'hidden' }}>
          {idCardCheck ? (
            <div styleName="card">
              <div styleName="info">
                <div style={{ fontSize: '16px', color: '#969696' }}>
                  身份证照片已上传
                </div>
                {/* <div styleName="bottom">23543245</div> */}
              </div>
              <div styleName="option alone">
                <div styleName="alone-item" onClick={handleDelete}>
                  <IconFont type="iconshanchu" />
                  <span>删除卡片</span>
                </div>
              </div>
            </div>
          ) : (
            <div onClick={handleAddIdCard} styleName="card empty">
              <IconFont styleName="icon" type="iconzengjia" />
              <span>新增身份证照</span>
            </div>
          )}
        </div>
      </PageWrapper>
      <AddIdCard />
    </div>
  )
}
export default connect(({ global }) => {
  return {
    idCardCheck: global.idCardCheck,
  }
})(IdCard)
